import axios from 'axios'
import {FC, useEffect, useState} from 'react'
import {useParams} from 'react-router-dom'

type Props = {
  data: any
}
const API_URL = process.env.REACT_APP_API_URL || 'api'

const EvaluationReportDownloadCell: FC<Props> = ({data}) => {
  const [file, setFile] = useState()
  const {id}: any = useParams()
  const loadLaudo = (propertyId: number, evaluationReportNumber: string | undefined) => {
    getLaudo()
    let fields: any = []
    async function getLaudo() {
      const {data} = await axios.get(`${API_URL}/sgt/v1/evaluation_reports/generate_pdf`, {
        params: {
          property_id: propertyId,
          evaluation_report_number: evaluationReportNumber,
        },
      })
      setFile(data)
    }
    return fields
  }

  useEffect(() => {
    loadLaudo(id, data.evaluation_report_number)
  }, [])

  console.log('file url', file)
  return (
    <>
      <div className='d-flex flex-column align-items-md-center'>
        <a
          href={`${file}`}
          // href='#'
          download='{laudo}'
          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
        >
          <i className='bi bi-file-earmark-arrow-down-fill fs-3'></i>
        </a>
      </div>
    </>
  )
}

export {EvaluationReportDownloadCell}
